import { render, staticRenderFns } from "./CommercialInvoices.vue?vue&type=template&id=232ffb9f"
import script from "./CommercialInvoices.vue?vue&type=script&lang=js"
export * from "./CommercialInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports